import {useEffect} from "react";
import {useSelector} from "react-redux";
import {brandSelector} from "store/selectors/brandSelector";
import {BrandEnum} from "utils/brand";

export const useBrandedResources = () => {
    const brand = useSelector(brandSelector);

    useEffect(() => {
        if (brand && brand === BrandEnum.HOPP) {
            const manifest = document.getElementById("manifest-id");
            if (manifest) {
                manifest.setAttribute("href", "/manifest__hopp.json");
            }

            const icon = document.getElementById("icon-id");
            if (icon) {
                icon.setAttribute("href", "/favicon__hopp.ico");
            }

            const appleTouchIcon = document.getElementById("apple-touch-icon-id");
            if (appleTouchIcon) {
                appleTouchIcon.setAttribute("href", "/logo192__hopp.png");
            }
        }
    }, [brand]);
};
